import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase/firebase";
import Stripe from "stripe";

export async function getStripeCheckoutSession(CustomerId: string): Promise<Stripe.Checkout.Session> {

    const getStripeCheckoutSessionFunction = httpsCallable(functions, 'getStripeCheckoutSession');

    const result = await getStripeCheckoutSessionFunction({
        customerId: CustomerId
    });
    const stripeSession = result.data as Stripe.Checkout.Session;

    return stripeSession;
}

export async function getStripeCustomerSubscriptions(CustomerId: string): Promise<Stripe.Subscription[]> {

    const getStripeCustomerSubscriptionsFunction = httpsCallable(functions, 'getStripeCustomerSubscriptions');

    const result = await getStripeCustomerSubscriptionsFunction({
        customerId: CustomerId
    });
    const subscriptions = result.data as Stripe.Subscription[];

    return subscriptions;
}